import React from 'react'
import { Link } from 'react-router-dom'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import bot1 from '../Assets/Image/about-bot-back.jpg';
import bot2 from '../Assets/Image/nexus-bot.png';
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import SsidChartIcon from '@mui/icons-material/SsidChart';
import ScienceIcon from '@mui/icons-material/Science';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import GroupIcon from '@mui/icons-material/Group';
import Accordion from 'react-bootstrap/Accordion';
import bot3 from '../Assets/Image/about-us2.jpg';
import bot4 from '../Assets/Image/teams.jpg';
import bot5 from '../Assets/Image/teams2.jpg';
import bot6 from '../Assets/Image/teams3.jpg';


export default function About() {
    return (
        <div>
            <section className='abouts'>
                <div className='container'>
                    <div className="row">
                        <div className="col-12">
                            <div className="about-heading">
                                <div className="about-hone">
                                    <h1>About Nexus Tradezz</h1>
                                </div>
                                <div className="head-point">
                                    <ul>
                                        <li><Link to='#'>Home</Link></li>
                                        <li><ArrowForwardIosIcon /></li>
                                        <li>About Us</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='abouts-two'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5">
                            <div className="abouts-contents">
                                <div className="abouts-two-upper">
                                    <h5>ABOUT COMPANY</h5>
                                    <h1>Nexus Tradezz: Redefining Forex Excellence complex issues.</h1>
                                </div>
                                <div className="about-two-bottom">
                                    <div className="about-two-data">
                                        <h5>Expertise You Can Trust</h5>
                                        <p>We specialize in resolving complex trading challenges with precision and innovation.</p>
                                    </div>
                                    <div className="about-two-data">
                                        <h5>AI-Driven Trading for Smarter Investments</h5>
                                        <p>Harness the power of intelligent algorithms to make data-backed decisions, minimize risks, and maximize profits effortlessly.</p>
                                    </div>
                                    <div className="about-two-data">
                                        <h5>Secure, Fast & Profit-Optimized Solutions</h5>
                                        <p>With cutting-edge technology and robust security, we ensure a lightning-fast, secure, and profitable trading experience.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="abouts-two-pic">
                                <img className='bot-pic' src={bot1} alt="" />
                                <img className='bot-pic1' src={bot2} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='abouts-three'>
                <div className="container-fluid p-0">
                    <div className="row">
                        <div className="col-lg-2 col-md-4 col-sm-6 p-0">
                            <div className="about-three-details">
                                <div className="about-three-icon">
                                    <ThumbUpOffAltIcon />
                                </div>
                                <div className="about-three-cont">
                                    <h5>Trusted company</h5>
                                    <p>Reliable & secure Forex trading.</p>
                                </div>
                                <div className='feature-box-overlay bg-base-color'></div>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4 col-sm-6 p-0">
                            <div className="about-three-details">
                                <div className="about-three-icon">
                                    <WorkOutlineIcon />
                                </div>
                                <div className="about-three-cont">
                                    <h5>Professional work</h5>
                                    <p>Reliable & secure Forex trading.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4 col-sm-6 p-0">
                            <div className="about-three-details">
                                <div className="about-three-icon">
                                    <SsidChartIcon />
                                </div>
                                <div className="about-three-cont">
                                    <h5>Consistent growth</h5>
                                    <p>Reliable & secure Forex trading.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4 col-sm-6 p-0">
                            <div className="about-three-details">
                                <div className="about-three-icon">
                                    <ScienceIcon />
                                </div>
                                <div className="about-three-cont">
                                    <h5>Expert advisors</h5>
                                    <p>Reliable & secure Forex trading.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4 col-sm-6 p-0">
                            <div className="about-three-details">
                                <div className="about-three-icon">
                                    <EmojiEventsIcon />
                                </div>
                                <div className="about-three-cont">
                                    <h5>Award winning</h5>
                                    <p>Reliable & secure Forex trading.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4 col-sm-6 p-0">
                            <div className="about-three-details">
                                <div className="about-three-icon">
                                    <GroupIcon />
                                </div>
                                <div className="about-three-cont">
                                    <h5>Dedicated team</h5>
                                    <p>Reliable & secure Forex trading.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='abouts-four'>
                <div className="container-fluid p-0">
                    <div className="row">
                        <div className="col-lg-6 p-0">
                            <div className="about-four-details">
                                <h1>Nexus Tradezz: Elevate Your Forex Success
                                </h1>
                                <p>We empower traders with cutting-edge AI technology, expert strategies, and seamless automation to maximize profits and minimize risks. </p>
                                <div className="abouts-four-accor">
                                    <Accordion className='abouts-accor'>
                                        <Accordion.Item className='accor-item' eventKey="0">
                                            <Accordion.Header className='accor-heads'>AI-Driven Trading Precision</Accordion.Header>
                                            <Accordion.Body className='accor-body'>
                                                Leverage the power of intelligent algorithms to execute trades with accuracy, speed, and efficiency, ensuring optimized returns.
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item className='accor-item' eventKey="1">
                                            <Accordion.Header>Secure & Reliable Trading</Accordion.Header>
                                            <Accordion.Body className='accor-body'>
                                                Trade with confidence using our highly secure platform, built with advanced encryption and risk management for ultimate protection.
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item className='accor-item' eventKey="2">
                                            <Accordion.Header>Lightning-Fast Execution</Accordion.Header>
                                            <Accordion.Body className='accor-body'>
                                                Stay ahead in the market with ultra-fast trade execution, reducing slippage and maximizing profitability in real-time trading.
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item className='accor-item' eventKey="3">
                                            <Accordion.Header> Proven Strategies for Maximum Growth</Accordion.Header>
                                            <Accordion.Body className='accor-body'>
                                                Benefit from expert-backed strategies designed for consistent profits and long-term financial success in the Forex market.
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item className='accor-item' eventKey="4">
                                            <Accordion.Header>AI Forex Bot – Trade Smarter, Not Harder</Accordion.Header>
                                            <Accordion.Body className='accor-body'>
                                                Our intelligent Forex bot works 24/7, analyzing trends and making precise trades, so you earn even while you sleep
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 p-0">
                            <div className="abouts-four-pic">
                                <img src={bot3} />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='abouts-five'>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="abouts-five-heading">
                                <h5>Industry Leaders on</h5>
                                <h2>Smart Forex Investments</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row abouts-five-row">
                        <div className="col-xl-4 col-lg-6 col-md-6">
                            <div className="abouts-five-details">
                                <div className="abouts-five-upper">
                                    <p>Successful trading is about patience and strategy. With platforms like Nexus Tradezz, AI-driven trading makes smarter investments possible.</p>
                                </div>
                                <div className="abouts-five-bottom">
                                    <div className="abouts-five-pic">
                                        <img src={bot4} alt="client" />
                                    </div>
                                    <div className="abouts-five-name">
                                        <h5>Warren Buffett</h5>
                                        <p>Legendary Investor</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-6 col-md-6">
                            <div className="abouts-five-details">
                                <div className="abouts-five-upper">
                                    <p>Forex is a game of precision. Nexus Tradezz leverages technology to give traders the edge they need to win.</p>
                                </div>
                                <div className="abouts-five-bottom">
                                    <div className="abouts-five-pic">
                                        <img src={bot5} alt="client" />
                                    </div>
                                    <div className="abouts-five-name">
                                        <h5>George Soros</h5>
                                        <p>Forex Trading Icon</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-6 col-md-6">
                            <div className="abouts-five-details">
                                <div className="abouts-five-upper">
                                    <p>Markets reward the prepared. Nexus Tradezz ensures traders have the right tools for profitable decisions</p>
                                </div>
                                <div className="abouts-five-bottom">
                                    <div className="abouts-five-pic">
                                        <img src={bot6} alt="client" />
                                    </div>
                                    <div className="abouts-five-name">
                                        <h5>Paul Tudor Jones</h5>
                                        <p>Hedge Fund Billionaire</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='abouts-six'>
                <div className="container">
                    <div className="row">
                        <div className="col-md-4">
                            <div className="abouts-six-cont">
                                <h4>Smart Ideas, Bigger Profits!</h4>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="abouts-six-pic">
                                <img src={bot2} alt="bot6" />
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="abouts-six-cont">
                             <p>Unlock innovative strategies to grow and optimize your funds with expert-driven insights.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}